import { Component } from "react";
import "./Payform.css";

export class Payform extends Component {
  constructor() {
    super();
    this.state = {
      planPick: 1,
      usersData: localStorage.getItem("user_data")
        ? JSON.parse(localStorage.getItem("user_data"))
        : {},
    };
  }

  componentDidMount() {}

  doClosePop = () => {
    document.querySelector(".payform-info-popup").classList.remove("active");
  };

  render() {
    return (
      <div className="payform-info-popup payform-info-popup-bank">
        <div className="pfp_window">
          <div
            className="pfp_close"
            onClick={() => {
              this.doClosePop();
            }}
          >
            &times;
          </div>
          <div className="pfp_title">Uplata direktno preko uplatnice</div>
          <div className="pfp_text">
            Izaberite opciju koju želite da platite:
          </div>

          <div className="payments_price_sections">
            <div
              className={
                "pay_price_one " +
                (this.state.planPick == 1 ? "activeprice" : "")
              }
              onClick={() => {
                this.setState({ planPick: 1 });
              }}
            >
              <div className="pay_topprice">
                <div>
					57 <span>KM</span>
				  </div>
				  20 <span>KM</span>
              </div>
              <div className="pay_toppricesub">mjesečno</div>
            </div>

            <div
              className={
                "pay_price_one " +
                (this.state.planPick == 2 ? "activeprice" : "")
              }
              onClick={() => {
                this.setState({ planPick: 2 });
              }}
            >
              <div className="pay_topprice">
                <div>
                  684 <span>KM</span>
                </div>
                250 <span>KM</span>
              </div>
              <div className="pay_toppricesub">godišnje</div>
            </div>
          </div>

          <div className="pfp_uplatnica">
            <div className="pfp_sender">
              {this.state.usersData && this.state.usersData.first_name
                ? this.state.usersData.first_name
                : "Ime"}{" "}
              {this.state.usersData && this.state.usersData.last_name
                ? this.state.usersData.last_name
                : "Prezime"}
              <br />
              {this.state.usersData && this.state.usersData.address
                ? this.state.usersData.address
                : "Adresa"}
              ,{" "}
              {this.state.usersData && this.state.usersData.city
                ? this.state.usersData.city
                : "Grad"}
            </div>
            <div className="pfp_payreason">
              Uplata za korištenje portala
              <br />
              Korisnicko ime:{" "}
              {this.state.usersData && this.state.usersData.name
                ? this.state.usersData.name
                : "korisničko ime"}
            </div>
            <div className="pfp_payto">
              OPK.ba d.o.o. <br />
              Svetog Save 6, Zvornik
            </div>

            <div className="pfp_accountno">5722860000679881</div>
            <div className="pfp_pricetag">
              ={this.state.planPick == 1 ? "20.00" : "250.00"}
            </div>
          </div>
          <br />
          <div className="pfp_text">
            Uplate na račun: <b>572-286-00006798-81</b>
          </div>
          <div className="pfp_text">
            Kod uplate <b>obavezno</b> naznačiti korisničko ime{" "}
            <b>
              {this.state.usersData && this.state.usersData.name
                ? this.state.usersData.name
                : ""}
            </b>
          </div>
        </div>
      </div>
    );
  }
}
